import useFeatureFlag from './useFeatureFlag'

export const DASHBOARD_REPORTING_FEATURE = 'dashboard-reporting'

// Gates the Datacenter + Dashboard reporting epic (SYN-4024): CSV exports, dashboard filters,
// employee utilization, and removing the Estimates card from the dashboard.
const useDashboardReporting = (): boolean => useFeatureFlag(DASHBOARD_REPORTING_FEATURE)

export default useDashboardReporting
